import { install } from 'resize-observer';

// This polyfill is needed to support Embla in older browsers that don't support ResizeObserver, such Safari iOS < 13.4
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  // Bless this user for their helpful comment! https://stackoverflow.com/a/74607498
  install();
}
